import {Chip, Grid} from "@mui/material";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import {displayDay, formatCurrency, inventoryAvailable, maxMatrixPrice, truncDetail} from "../common/Utils";
import React from "react";
import InventoryImage from "./InventoryImage";
import Icon from "@mui/material/Icon";

export default function EventDetail({event, children, full, showRegistration, packages, callback}) {

  const eventDetail = (event, full, showRegistration) => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={2} md={3}>
          <center>
            <InventoryImage
              sx={{
                fontSize: '42px',
              }}
              inventory={event}/>
          </center>
        </Grid>
        <Grid item xs={12} sm={10} md={9}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDBox>
                <MDTypography variant="h4" fontWeight="bold" color="primary">
                  {event.name}
                </MDTypography>
              </MDBox>
              {event?.memberAccount && <h6>
                <Icon>shopping_bag</Icon>&nbsp;{event?.memberAccount?.name}
              </h6>
              }
              <MDBox my={2}>
                <p style={{
                  whiteSpace: 'pre-wrap',
                }}>
                  {full ? event.desc : truncDetail(event.desc, 35)}
                </p>
              </MDBox>
              {!event.sessionEvent && <MDBox>
                <MDTypography variant="h6" fontWeight="regular" color="secondary">
                  Event
                  Date:
                  <>
                    {event.allDay && <b>&nbsp;All Day</b>}
                    {!event.allDay &&
                      <b>&nbsp;{displayDay(event.eventDate, 'MM/DD/YYYY h:mm')} - {displayDay(event.eventEndDate, 'h:mm a')}</b>}
                  </>
                </MDTypography>
              </MDBox>}
              {event.sessionEvent && <>
                <MDTypography variant="h6" fontWeight="regular" color="secondary">
                  <b>Session Event Times</b>
                </MDTypography>
                {event.sessionEvents.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
                  .map((a, idx) => {
                    return (
                      <MDBox key={idx}>
                        <MDTypography variant="p" fontWeight="regular" color="secondary">
                          Event Date: <b>{displayDay(a.eventDate, 'MM/DD/YYYY h:mm a')}</b>
                        </MDTypography>
                      </MDBox>
                    )

                  })
                }
              </>}
              <MDBox my={2}>
                <MDTypography variant="p" fontWeight="regular" color="secondary">
                  Age: <b>{event.ageRange?.name}</b>
                </MDTypography>
              </MDBox>
              <MDBox my={2}>
                <MDTypography variant="p" fontWeight="regular" color="secondary">

                  {event?.eventType?.specialEvent ? 'Event Size' : 'Available'}: <b>{inventoryAvailable(event)}</b>

                </MDTypography>
              </MDBox>

              <div className="mb-2">
                <Chip
                  label={event.eventType?.name}
                  variant="outlined"
                  color="secondary"/>&nbsp;

                {event?.eventType?.memberOnly &&
                  <>
                    <Chip
                      label={'Membership Required'}
                      variant="outlined"
                      color="secondary"/>&nbsp;</>
                }

                {!event?.eventType?.memberOnly &&
                  <>
                    <Chip
                      label={(event?.packageRequired ? 'Starting ' : '') + 'Price: ' + (event?.eventMatrix != null ? formatCurrency(maxMatrixPrice(event)) : formatCurrency(event.price))}
                      variant="outlined"
                      color="secondary"/>
                    &nbsp;</>
                }

                {event?.sessionEvent && <><Chip label="Session"
                                                variant="filled"
                                                color="info"/>&nbsp;</>
                }
              </div>

              {children}

              {(full || showRegistration) && <>
                {/*<p>TODO</p>*/}
                {/*<EventRegistration event={event}/>*/}
              </>
              }
            </Grid>
          </Grid>


        </Grid>
      </Grid>
    )
  }

  return (
    <>
      {event && eventDetail(event, full, showRegistration)}
    </>
  )
}